/* eslint-disable lines-around-comment */
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';

// utilities
import _, {get, isEmpty} from 'lodash';

// action creators for redux
import * as syncActionCreators from '../../redux/actionCreators/sync';
import { logOut } from '../../redux/actionCreators/async/auth';
import * as asyncActionCreators from '../../redux/actionCreators/async';
import * as ui from '../../redux/actionCreators/sync/ui';
import * as impersonationApi from '../../redux/actionCreators/async/impersonation';

// components
import ModalX from '../../common/svgs/ModalX';
import Modal from '../../common/components/r_Modal';
import Button from '../../common/components/Button';
import NavColumn from './f_NavColumn';
import Application from './f_Application';
import Assessment from './r_ApplicantAssessment';
import ApplicantTerms from './r_ApplicantTermsAndConditions';
import TechnologySurveyContainer from '../applicant/TechnologySurvey/TechnologySurveyContainer';
import RouteTransitionBlocker from './f_RouteTransitionBlocker';
import InfoModal from '../../common/components/f_InfoModal';
import ApplicantMenu from '../f_applicantMenu';
import JoveoTrackingPixel from '../f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/JoveoTrackingPixel';

// view ordering array of arrays
import {viewOrderArr} from './viewOrderArr';
import {appViewState} from './appViewState';
import * as applicantHelpers from '../applicant/helpers/status';


@connect((state, props) => ({
  user: state.user,
  profile: state.applicantProfile,
  workExperience: state.workExperience,
  licenses: state.licenses,
  scrollBarWidth: state.browserData.scrollBarWidth,
  activeColumnNav: props.params.activeColumnNav,
  activeRowSubNav: props.params.activeRowSubNav || null,
  tempState: state.tempState,
  staticData: state.staticData,
  skills: state.skills,
  labels: get(state.labels, 'Common', {}),
  viewOrderArrLabels: get(state.labels, 'Application.viewOrderArr.nav', {})
}), ({
  showControls: ui.showControls,
  push,
  updateTempState: syncActionCreators.updateTempState,
  getProfileById: asyncActionCreators.getProfileById,
  logOut
}))
class ApplicantDashboard extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    push: PropTypes.func.isRequired,
    updateTempState: PropTypes.func.isRequired,
    getProfileById: PropTypes.func.isRequired,
    logOut: PropTypes.func.isRequired,
    scrollBarWidth: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    profile: PropTypes.object,
    workExperience: PropTypes.object,
    licenses: PropTypes.object,
    tempState: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    columnState: PropTypes.string,
    rowState: PropTypes.string,
    skills: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    viewOrderArrLabels: PropTypes.object.isRequired,
    isInactivePipeline: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.viewOrderArr = this.mapSkillsViewOrderArr();
    this.appViewState = this.mapSkillsAppViewState();

    this.state = this.initializeState(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.transitionBlockingRoute.length === 0) {
      this.setState(_.merge({}, this.state, this.initializeState(nextProps)));
    }
  }

  mapSkillsViewOrderArr() {
    // construct new skills subnav array using staticData skillCategoryTypes
    const {
      staticData,
      viewOrderArrLabels,
    } = this.props;

    return viewOrderArr.map((col) => {
      if (col.display === 'Skills') {

        // concat instructions page to beginning
        col.subNav = [{display: 'Introduction', key: 'Instructions'}]
          .concat(
            _.orderBy(staticData.skillCategoryTypes, ['order'], ['asc'])
            .map((cat) => { return { display: cat.name, key: cat.url_query_string };
          }));
      }

      if (col.display === 'Background') {
        col.subNav = col.subNav.map((sub) => {
          if (sub.display === 'Professional Designations') {
            sub.display = get(viewOrderArrLabels, 'background.professionalDesignations');
          }
          return sub;
        });
      }

      return col;
    });
  }


  mapSkillsAppViewState() {
    const newAppViewState = _.merge({}, appViewState);

    newAppViewState.Skills = this.props.staticData.skillCategoryTypes.reduce((obj, skillType) => {
      obj[skillType.url_query_string] = { done: false };
      return obj;
    }, { Instructions: { done: false }});

    return newAppViewState;
  }

  initializeState(props) {

    const currentColumnIndex = this.viewOrderArr.findIndex(col => col.key === this.props.activeColumnNav);
    const currentColumn = (this.viewOrderArr[currentColumnIndex])? this.viewOrderArr[currentColumnIndex] : this.viewOrderArr[0];
    const currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(val => val.key === this.props.activeRowSubNav) : -1; // using binary flip '~' so -1 will flip to falsey
    const applicantStatus = _.get(props.profile, 'applicantStatus', 0);

    return {
      adjustProgressView: Math.max(currentRowIndex - 2, 0), // for scooching progress bar, if more than 5 items, move current one to the middle
      transitionBlockingRoute: '',
      transitionAdjustProgressView: null,
      showLogoutModal : false,
      canShowAssessment: applicantHelpers.enableAssessments(applicantStatus), // Pending Assessments.
      isQualified: applicantHelpers.isQualified(applicantStatus),
      hasInterviewed: applicantHelpers.hasInterviewed(applicantStatus),
      submitted: applicantHelpers.hasSubmitted(props.profile),
      showAssessmentFlag: props.location.pathname === '/applicant/Assesments',
      showTermsFlag: props.location.pathname === '/applicant/TermsAndPrivacy',
      showTechnologySurveyFlag: props.location.pathname === '/applicant/TechnologySurvey',
      canShowTechnologySurvey: applicantHelpers.enableTechnologySurvey(applicantStatus), // Show technology for "Pending Reference Checks" or "Ready to Place".
      showInstructions: applicantHelpers.enableInstructions(applicantStatus),
      isInactivePipeline: applicantHelpers.isInactivePipeline(applicantStatus)
    };
  }

  // eslint-disable-next-line no-unused-vars
  navSkillsChange = (activeColumnNav, activeRowSubNav, adjustProgressView) => {
    const newLocation = `/applicant/${activeColumnNav}${activeRowSubNav ? `/${activeRowSubNav}` : ''}`;
    const summaryOFSkills = encodeURI('/applicant/Summary of Skills/Summary of Skills');

    const incompletedSkills = _.chain(this.props.skills)
      .values()
      .map(i => _.values(i))
      .flatten() // Convert the multilevel object in flatten array.
      .filter(skill => skill.name !== 'None') // Filter out everything set to none.
      .filter(skill => !skill.lastUsed || !skill.yearsOfExperience || !skill.skillLevel) // If something is missing keep it.
      .value();


    if (_.startsWith(location.pathname, '/applicant/Skills/')) {
      if (_.startsWith(newLocation, '/applicant/Skills/') || encodeURI(newLocation) === summaryOFSkills) {
        return true;
      }

      return !(incompletedSkills.length);
    }

    return true;
  }

  navStateChange = (activeColumnNav, activeRowSubNav, adjustProgressView) => {
    if (!this.navSkillsChange(activeColumnNav, activeRowSubNav, adjustProgressView)) {
      return this.setState({blockRoutes: true});
    }

    let filledFlag;
    const orSkills = this.props.skills;

    filledFlag  = false;
    // eslint-disable-next-line no-unused-vars
    const _this = this;

    // add check for skills last page only. Checking if all skills are fullfilled
    if(_.isEmpty(this.props.tempState) && (this.props.params.activeColumnNav === 'Summary of Skills') && (this.props.params.activeRowSubNav === 'Summary of Skills')) {
      // eslint-disable-next-line no-unused-vars
      const skillsAreFilled = _(orSkills).forEach((value, key) => {
        if(!orSkills[key].hasOwnProperty('None')) {
          // eslint-disable-next-line no-unused-vars
          _(value).forEach((skill, name) => {
            if(!skill.lastUsed && !skill.skillLevel && !skill.yearsOfExperience) filledFlag = true;
          });
        }
      });
    }

    const finalAdjustProgressView = typeof adjustProgressView === 'number' ?
      Math.max(adjustProgressView, 0) : // if clicking next or back then scooch row nav
      activeColumnNav !== this.props.activeColumnNav ? 0 : // if column nav changes, move back to zero adjustment
      this.state.adjustProgressView; // if navigation happens via row nav then don't change adjustment to row nav

    // for some reason dispatch on save has not taken place when you get here, forcing to the bottom of the call stack with setTimeout :(
    this.setState({
      showAssessmentFlag:false,
      showTermsFlag:false,
      showTechnologySurveyFlag: false,
    });

    setTimeout(() => {
        if((!_.isEmpty(this.props.tempState) && !(this.props.activeColumnNav === 'Skills' && this.props.activeRowSubNav === 'Instructions')) || filledFlag) {
          this.setState({
            ...this.state,
            transitionBlockingRoute: `/applicant/${activeColumnNav}${activeRowSubNav ? `/${activeRowSubNav}` : ''}`,
            transitionAdjustProgressView: finalAdjustProgressView
          });
        } else {
          this.setState({
            ...this.state,
            adjustProgressView: finalAdjustProgressView
          }, () => this.props.push(`/applicant/${activeColumnNav}${activeRowSubNav ? `/${activeRowSubNav}` : ''}`));
        }
        this.props.showControls();
      });
  }

  closeTransitionBlocker = (cb, adjustProgressView) => {
    // store transition route here temporarily as it will get wiped off of local state
    const transitionRoute = this.state.transitionBlockingRoute;

    const newState = {
      transitionBlockingRoute: '',
      transitionAdjustProgressView: null,
      showResults: false
    };

    if(!_.isNil(adjustProgressView)) {
      _.set(newState, 'adjustProgressView', adjustProgressView);
    }

    // get rid of transition blocker pop-up + route
    this.setState(newState, typeof cb === 'function' && cb(transitionRoute) || null);
  }

  stepBackward = () => {
    let nextColKey; // default to current colNav (only move forward if row navs are used up)
    let nextRowKey;
    let nextRowIndex;

    const currentColumnIndex = this.viewOrderArr.findIndex(col => col.key === this.props.activeColumnNav);
    const currentColumn = this.viewOrderArr[currentColumnIndex];
    const currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(val => val.key === this.props.activeRowSubNav) : -1; // using binary flip '~' so -1 will flip to falsey

    if(~currentRowIndex && currentRowIndex > 0) { // if index is found and index is less than rowSubNav length
      nextColKey = this.props.activeColumnNav;
      nextRowIndex = currentRowIndex - 1;
      nextRowKey = currentColumn.subNav[nextRowIndex].key;
    } else {
      const incrementedColumn = this.viewOrderArr[currentColumnIndex - 1];
      nextColKey = incrementedColumn.key;
      nextRowIndex = _.get(incrementedColumn, ['subNav', 'length'], 1) - 1;
      nextRowKey = _.get(incrementedColumn, ['subNav', nextRowIndex, 'key'], null);
    }

    // for scooching progress bar
    const adjustProgressView = nextRowIndex - this.state.adjustProgressView < 1 ? Math.max(nextRowIndex - 1, 0) : // move one ahead of the beginning
      nextRowIndex - this.state.adjustProgressView > 3 ? nextRowIndex - 3 : // handle if you've moved to the previous 'column'
      null; // if in the middle of view don't move at all

    this.navStateChange(nextColKey, nextRowKey, adjustProgressView);
  }

  stepForward = () => {
    let nextColKey; // default to current colNav (only move forward if row navs are used up)
    let nextRowKey;
    let nextRowIndex;
    let showUnqualified;

    const currentColumnIndex = this.viewOrderArr.findIndex(col => col.key === this.props.activeColumnNav);
    const currentColumn = this.viewOrderArr[currentColumnIndex];
    const currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(val => val.key === this.props.activeRowSubNav) : -1; // using binary flip '~' so -1 will flip to falsey

    if(~currentRowIndex && currentRowIndex < currentColumn.subNav.length - 1) { // if index is found and index is less than rowSubNav length
      showUnqualified = currentColumn.showUnqualified;
      nextColKey = this.props.activeColumnNav;
      nextRowIndex = currentRowIndex + 1;
      nextRowKey = currentColumn.subNav[nextRowIndex].key;
    } else {
      const incrementedColumn = this.viewOrderArr[currentColumnIndex + 1];
      showUnqualified = incrementedColumn.showUnqualified;
      nextColKey = incrementedColumn.key;
      nextRowIndex = 0;
      nextRowKey = _.get(incrementedColumn, ['subNav', nextRowIndex, 'key'], null);
    }

    if (showUnqualified || this.state.hasInterviewed) {
      // for scooching progress bar
      const adjustProgressView = nextRowIndex - this.state.adjustProgressView > 3 ? Math.max(nextRowIndex - 3, 0) : // move one behind the end
        nextRowIndex === 0 ? 0 : // handle if you've moved to a next 'column'
        null; // if in the middle of view don't move at all

      this.navStateChange(nextColKey, nextRowKey, adjustProgressView);
      return true;
    }
    // eslint-disable-next-line no-else-return
    else {
      return false;
    }
  }

  submitApplication = () => {
    this.setState({showResults:true, transitionBlockingRoute: '/applicant/Profile/Contact Information'});
  }
  closeModal = () => {
    this.setState({showResults:false});
  }
  showAssessment =() => {
    this.navStateChange('Assesments', 0, 0);
    this.setState({showAssessmentFlag:true});
  }
  showTechnologySurvey =() => {
    this.navStateChange('TechnologySurvey', 0, 0);
    this.setState({showTechnologySurveyFlag:true});
  }
  showTerms =() => {
    this.navStateChange('TermsAndPrivacy', 0, 0);
    this.setState({showAssessmentFlag:true, showTermsFlag: true});
  }

  moveToSumarySkills = () => {
    this.setState({ blockRoutes: false }, () => {
      this.props.push('/applicant/Summary of Skills/Summary of Skills');
    });
  }

  handleLogOut = (warn = true) => {
    const {website} = this.props.labels;
    const {tempState, user} = this.props;

    if (user.impersonateUser) {
      impersonationApi.deleteImpersonation()
      .then(() => {
        if (window) {
          if (window) window.close();
        }
      });

      return;
    }
    else if (!isEmpty(tempState) && warn) {

      this.setState({showLogoutModal: warn});
      return;
    }

    this.props.logOut()
      .then(() => {
        window.location = website;
      })
    ;

  }

  hideLogoutWarning = () => {
    this.setState({showLogoutModal: false});
  }

  // eslint-disable-next-line no-unused-vars
  renderLogoutModal(state, props) {
    const {showLogoutModal} = this.state;

    if (showLogoutModal) {

      return(
        <Modal>
          <div className='route-transition-blocker-transition-block-form'>
            <ModalX onClick={this.hideLogoutWarning}/>
            <div>
              <div className='prompt-text'>
                You have not saved all your changes.
                If you exit the application now you will lose the information that hasn’t been saved.
              </div>
              <div className='logout-buttons'>
                <Button
                  className={'button-main-large'}
                  label={'Stay'}
                  onClick={this.hideLogoutWarning}
                />
                <Button
                  className={'button-secondary-large'}
                  label={'Leave'}
                  onClick={() => this.handleLogOut(false)}
                />
              </div>
            </div>
          </div>
          <div className='rectangle-behind-modal-form absolute-center'/>
        </Modal>
      );

    }
  }

  render() {
    const isFirst = // boolean to check if first form (first row val of first column)
      this.props.activeColumnNav === this.viewOrderArr[0].key
      &&
      (
        !this.viewOrderArr[0].subNav
        ||
        this.viewOrderArr[0].subNav[0].key === this.props.activeRowSubNav
      );
    const isLast = // boolean to check if last form (last row val of last column)
      this.props.activeColumnNav === this.viewOrderArr[this.viewOrderArr.length - 1].key
      &&
      (
        !this.viewOrderArr[this.viewOrderArr.length - 1].subNav
        ||
        this.viewOrderArr[this.viewOrderArr.length - 1].subNav[this.viewOrderArr[this.viewOrderArr.length - 1].subNav.length - 1].key === this.props.activeRowSubNav
      );

    const navViewState = _.chain(_.get(this.props.profile, 'viewState.progress.applicant.application', this.appViewState)).omit(['firstTime']).clone().mapValues(prop => prop.done || _.every(prop, subProp => subProp.done)).value();

    const {
      Submit: submitDone,
      ...nonSubmitViewState
    } = navViewState;

    const requiredSections = {
      Profile: false,
      Preferences: false,
      Experience: false,
      Skills: false,
      'Summary of Skills': false,
      Background: false,
    };

    const completedSections = _.merge(
      {},
      requiredSections,
      _.omit(nonSubmitViewState, ['Welcome', 'Documents', 'Instructions', 'Submit', 'Assessments']),
    );

    const submitReady = _.every(completedSections, val => val);

    let applicantName = '';

    if (this.props.user.impersonateUser) {
      applicantName = `${_.get(this.props.user, 'impersonateUser.firstName', '')} ${_.get(this.props.user, 'impersonateUser.lastName', '')}`;
    } else {
      applicantName = `${_.get(this.props.user, 'firstName', '')} ${_.get(this.props.user, 'lastName', '')}`;
    }

    return (
      <div className='applicant-profile-container clearfix'>
        {
          this.state.transitionBlockingRoute
          &&
          <RouteTransitionBlocker
            cancelAction={this.closeTransitionBlocker}
            primaryAction={this.closeTransitionBlocker}
            secondaryAction={this.closeTransitionBlocker.bind(this, this.props.push, this.state.transitionAdjustProgressView)}
          />
        }
        {
          this.renderLogoutModal(this.state, this.props)
        }
        {/* TODO: whitelabel */}
        {
          this.state.showResults ?
            <div>
              <InfoModal
              cancelFunc={this.closeModal}
              transitionFunc={this.closeTransitionBlocker.bind(this, this.props.push)}
              buttonLabel='Close'
              // text={' <br /> We look forward to working with you.'}
              text={
                [`Thank you for completing the WAHVE application. We appreciate the time you have spent to provide us with all your professional information. You will receive an email from ${this.props.profile.qualifyingspecialist.firstName} ${this.props.profile.qualifyingspecialist.lastName} with the next steps. `,
                  <br />,
                  <br />,
                 ' We look forward to working with you.'
                ]}
              />
              <JoveoTrackingPixel conversionType='full-apply' />
            </div>
         : null
        }
        {
           this.state.blockRoutes &&
           <InfoModal
             transitionFunc={this.moveToSumarySkills}
             buttonLabel='COMPLETE INFO'
             text={
               [
                 'You must complete the required additional information on the',
                 <br />,
                 'Summary of Skills table for the new skill(s) you added and save',
                 <br />,
                 'your changes before continuing or logging out.',
               ]}
             />
         }
        <NavColumn activeColumnNav={this.props.activeColumnNav}
                   navStateChange={this.navStateChange}
                   navViewState={navViewState}
                   logoutFunc={this.logOut}
                   showAssessment={this.showAssessment}
                   showTerms={this.showTerms}
                   showTechnologySurvey={this.showTechnologySurvey}
                   assessment={this.state.showAssessmentFlag}
                   canShowAssessment={this.state.canShowAssessment}
                   canShowTechnologySurvey={this.state.canShowTechnologySurvey}
                   technologySurvey={this.state.showTechnologySurveyFlag}
                   isQualified={this.state.isQualified}
                   submitted={this.state.submitted}
                   hasInterviewed={this.state.hasInterviewed}
                   showInstructions={this.state.showInstructions}
                   isInactivePipeline={this.state.isInactivePipeline}
          />
        <div className='applicant-application-container'>
          <div className='applicant-profile-header'>
            <div className='applicant-welcome'>
                {
                  this.state.showTermsFlag ?  'PRIVACY NOTICE' : <h1>{applicantName}</h1>
                }
            </div>
            <ApplicantMenu
              logOut={this.handleLogOut}
            />
          </div>
          <div className='applicant-profile-form'>
          {
            (this.state.showAssessmentFlag &&  this.state.canShowAssessment && !this.state.showTermsFlag) ?
            <Assessment />
            : null
          }
          {
            (this.state.showTechnologySurveyFlag) ?
            <TechnologySurveyContainer  />
            : null
          }
          {
            this.state.showTermsFlag ? <ApplicantTerms /> : null
          }

            <Application
              activeColumnNav={this.props.activeColumnNav}
              activeRowSubNav={this.props.activeRowSubNav}
              navStateChange={this.navStateChange}
              adjustProgressView={this.state.adjustProgressView}
              isFirst={isFirst}
              isLast={isLast}
              stepBackward={this.stepBackward}
              stepForward={this.stepForward}
              submitApplication={this.submitApplication}
              viewData={_.get(this.props.profile, `viewState.progress.applicant.application.${this.props.activeColumnNav}`, this.appViewState[this.props.activeColumnNav])}
              rowSubNav={(this.viewOrderArr.find(nav => nav.key === this.props.activeColumnNav))?this.viewOrderArr.find(nav => nav.key === this.props.activeColumnNav).subNav : []}
              submitReady={!submitDone && submitReady}
              assessment={this.state.showAssessmentFlag}
              submitted={this.state.submitted}
              formSections={nonSubmitViewState}
              appViewState={this.appViewState}
            />

          </div>
      </div>
      {/* Handles hiding scrollbar, if scrollbar width is 0 it's the chromeless mac scrollbar which is 15px, still want to hide that */}
      <style>
        {
          `
            .application-section-container {
              width: calc(100%); //+ ${this.props.scrollBarWidth || '15'}px
              padding-right: ${this.props.scrollBarWidth || '15'}px;
            }
          `
        }
      </style>
    </div>
    );
  }
}

export default withRouter(ApplicantDashboard);



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/index.js